module.exports = __webpack_public_path__ + "static/img/solution_case3.6c31629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/solution_case3.png
// module id = VkFb
// module chunks = 34